import { render, staticRenderFns } from "./TimetableTemplateDetail.vue?vue&type=template&id=5fbd324d"
import script from "@/controllers/custom/timetable_template/timetable-template-detail.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/timetable_template/timetable-template-detail.js?vue&type=script&lang=js&external"
import style0 from "./TimetableTemplateDetail.vue?vue&type=style&index=0&id=5fbd324d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports